// src/services/ipService.ts
class IpService {
  private cachedIp: string | null = null;

  async getPublicIP(): Promise<string> {
    if (this.cachedIp) {
      return this.cachedIp;
    }

    try {
      // Opción 1: ipify (más confiable)
      const response = await fetch('https://api.ipify.org?format=json', {
        signal: AbortSignal.timeout(3000)
      });
      
      if (response.ok) {
        const data = await response.json();
        this.cachedIp = data.ip;
        console.log('🌐 [IP] IP pública obtenida:', this.cachedIp);
        return this.cachedIp;
      }
    } catch (error) {
      console.warn('⚠️ [IP] Error con ipify, intentando alternativa...');
    }

    try {
      // Opción 2: cloudflare (fallback)
      const response = await fetch('https://1.1.1.1/cdn-cgi/trace', {
        signal: AbortSignal.timeout(3000)
      });
      
      if (response.ok) {
        const text = await response.text();
        const ipMatch = text.match(/ip=([^\n]+)/);
        if (ipMatch) {
          this.cachedIp = ipMatch[1];
          console.log('🌐 [IP] IP pública obtenida (cloudflare):', this.cachedIp);
          return this.cachedIp;
        }
      }
    } catch (error) {
      console.warn('⚠️ [IP] Error obteniendo IP pública');
    }

    return 'Unknown';
  }

  clearCache() {
    this.cachedIp = null;
  }
}

export const ipService = new IpService();